import React, { useEffect } from "react";
import axios from "axios";
import "./JuridentPayment.css";
import JuridentPaymentConfig from "./config";

const JuridentFailure = () => {

  useEffect(() => {
    // Log failed payment to Cloud Function
    const logFailedPayment = async () => {
      try {
        const params = new URLSearchParams(window.location.search);

        // Check if environment mode is passed from Flutter app
        const isTestModeParam = params.get("isTestMode");
        if (isTestModeParam !== null) {
          // Override config with the mode passed from Flutter app
          JuridentPaymentConfig.isTestMode = isTestModeParam === 'true';
          console.log('🔧 [Config Override] Environment mode set from URL parameter:', isTestModeParam);
        }

        const userId = params.get('userId');
        const transactionId = params.get('transactionId');
        const amount = params.get('amount');
        const category = params.get('category');
        const phoneNo = params.get('phoneNo');
        const userName = params.get('userName');

        console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
        console.log('❌ LOGGING FAILED PAYMENT');
        console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
        console.log('User ID:', userId);
        console.log('Transaction ID:', transactionId);
        console.log('Amount (paise):', amount);
        console.log('Amount (rupees):', parseInt(amount) / 100);
        console.log('Category:', category);
        console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');

        // Get Cloud Function URL from config
        const CLOUD_FUNCTION_URL = JuridentPaymentConfig.cloudFunctionUrl;
        console.log('🔧 [Config] Using configuration:', JuridentPaymentConfig.environmentName);
        console.log('🔧 [Config] Cloud Function URL:', CLOUD_FUNCTION_URL);

        // Convert amount back to rupees for Cloud Function (it expects rupees, same as success page)
        const amountInRupees = parseInt(amount) / 100;

        const payload = {
          userId,
          transactionId,
          amount: amountInRupees, // Send in rupees, not paise
          category,
          phoneNo,
          userName,
          status: 'failed'
        };

        console.log('📤 Sending failure log:', payload);

        const response = await axios.post(CLOUD_FUNCTION_URL, payload, {
          headers: {
            'Content-Type': 'application/json'
          },
          timeout: 5000
        });

        console.log('✅ Failed transaction logged successfully');
        console.log('📥 Cloud Function Response:', response.data);

      } catch (error) {
        console.error('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
        console.error('❌ Error logging failed payment');
        console.error('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
        console.error('Error Type:', error.name);
        console.error('Error Message:', error.message);
        if (error.response) {
          console.error('Response Status:', error.response.status);
          console.error('Response Data:', error.response.data);
          console.error('Response Headers:', error.response.headers);
        } else if (error.request) {
          console.error('No response received:', error.request);
        } else {
          console.error('Request setup error:', error.message);
        }
        console.error('Full Error:', error);
        console.error('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
        // Don't block user flow if logging fails
      }
    };

    // Log failed payment
    logFailedPayment();
  }, []);

  return (
    <div className="jurident-payment-container">
      <div className="payment-card">
        {/* Environment Badge */}
        {JuridentPaymentConfig.isTestMode && (
          <div style={{
            background: '#ffc107',
            color: '#000',
            padding: '6px 12px',
            borderRadius: '20px',
            fontSize: '12px',
            fontWeight: '600',
            marginBottom: '15px',
            display: 'inline-block'
          }}>
            🧪 TEST MODE
          </div>
        )}

        <div className="error-icon">
          <svg
            width="80"
            height="80"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#dc3545"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
          </svg>
        </div>

        <h1 style={{ color: JuridentPaymentConfig.colors.error, textAlign: "center" }}>
          Payment Failed
        </h1>

        <p style={{ textAlign: "center", color: JuridentPaymentConfig.colors.textLight, marginBottom: "30px" }}>
          Your payment could not be processed. Please try again.
        </p>

        <div style={{
          background: JuridentPaymentConfig.colors.primaryLight + '20',
          borderLeft: `4px solid ${JuridentPaymentConfig.colors.primary}`,
          padding: "20px",
          borderRadius: "8px",
          marginBottom: "20px",
          textAlign: "center"
        }}>
          <p style={{ color: JuridentPaymentConfig.colors.text, margin: 0, fontSize: "16px", fontWeight: "500", lineHeight: "1.6" }}>
            You can close this browser and go back to the Jurident app
          </p>
        </div>

        <div className="security-badge">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
          <span>Your payment information is secure</span>
        </div>
      </div>
    </div>
  );
};

export default JuridentFailure;
